<div class="modal opened">
      <div class="modal-message-two">
        <div class="modal-message-main">
          <span class="modal-close" (click)="onButtonCloseClick($event)" title="Close">&#10005;</span>
          <h2>{{title}}</h2>
          <div class="txt" [innerHTML]="text"></div>
          <div class="element text-area">

            <core-helpers-forms-wysiwyg-extended
              [placeholder]="messagePlaceholder"
              [emojis]="false"
              (textChange)="onMessageChange($event)"
            ></core-helpers-forms-wysiwyg-extended>
          </div>
          <fieldset *ngIf="buttonEnabled">
            <core-helpers-forms-button
                [type]="buttonOneType"
                [text]="buttonOneText"
                (submit)="onButtonOneClick($event)"
            ></core-helpers-forms-button>
            <core-helpers-forms-button
                [type]="buttonTwoType"
                [text]="buttonTwoText"
                (submit)="onButtonTwoClick($event)"
            ></core-helpers-forms-button>
          </fieldset>
      </div>
    </div>
</div>
